var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiKtok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#F6F6F6",
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2806 7.29C19.4961 6.37945 19.0637 5.2103 19.0638 4H15.5166V18.4667C15.4898 19.2497 15.1648 19.9916 14.61 20.5357C14.0553 21.0799 13.3143 21.3838 12.5434 21.3833C10.9133 21.3833 9.55867 20.03 9.55867 18.35C9.55867 16.3433 11.4643 14.8383 13.4273 15.4567V11.77C9.46684 11.2333 6 14.36 6 18.35C6 22.235 9.16837 25 12.5319 25C16.1365 25 19.0638 22.025 19.0638 18.35V11.0117C20.5022 12.0615 22.2291 12.6248 24 12.6217V9.01667C24 9.01667 21.8418 9.12167 20.2806 7.29Z",
    fill: "#253B57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiKtok);
export default __webpack_public_path__ + "static/media/TIKtok.3c61bf51ca448ab79b7dfec468dc3044.svg";
export { ForwardRef as ReactComponent };